module.exports = __webpack_public_path__ + "img/2.533e295d.jpg";